import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  watch
} from '@vue/composition-api'
import _ from 'lodash'
import OptionSettings from '@/pages/Survey/SurveyManagement/components/SurveyDetail/compontents/optionSettings'
import CommonTetxEdit from '@/components/CommonTetxEdit'

const SectionEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },

  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const vm = getCurrentInstance()
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }

    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )
    return () => {
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.purp')}:
            </div> */}
            {/* <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.entpurp')}
              value={state.editItem.topicName}></RichUtil> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicName}
              placeholder={tran('survy.entpurp')}
              handleUpdate={(value) => {
                state.editItem.topicName = value
              }} />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings type={props.item.topicType} />
          </Portal>
        </div>
      )
    }
  }
})

export default SectionEdit
